import type {Link, Nodes, PhrasingContent} from 'mdast'

import {setOfAll} from '../../utils'
import type {ParentsOf} from '../syntax-tree/type-utils'

export const phrasingContentNodeTypes = setOfAll<
  Exclude<PhrasingContent['type'], 'inlinemath' | 'displaymath' | 'raw'>
>()(
  'break',
  'delete',
  'emphasis',
  'footnoteReference',
  'html',
  'image',
  'imageReference',
  'inlineCode',
  'link',
  'linkReference',
  'strong',
  'text',
  'delimiter',
)

// The explicit signature broadens the type so that TS will allow us to call `.has(node.type)` for any node
export type LinkParent = ParentsOf<Link>
export const linkParentNodeTypes: Set<Nodes['type']> = setOfAll<LinkParent['type']>()(
  'delete',
  'emphasis',
  'heading',
  'link',
  'linkReference',
  'paragraph',
  'strong',
  'tableCell',
  'root',
)

/** Node types that are allowed for creating links across boundaries (inline formatting only). */
export const inlineFormattingNodeTypes = new Set<Nodes['type']>([
  'delete',
  'delimiter',
  'emphasis',
  'inlineCode',
  'paragraph',
  'strong',
  'text',
  'root',
])
